import { PageHeaderWrapper, Text, Title } from "@clipboard-health/ui-components";
import { DialogContent, Stack } from "@mui/material";
import { Button } from "@src/appV2/redesign/components/Button";
import { DialogFooter } from "@src/appV2/redesign/components/DialogFooter";
import { LoadingButton } from "@src/appV2/redesign/components/LoadingButton";
import { PageHeaderTopRow } from "@src/appV2/redesign/components/PageHeaderTopRow";

const NO_BADGE_STEPS = [
  {
    number: 1,
    title: "Print out a badge",
    description:
      "Ask the front desk for a temporary badge or name sticker. Make sure your full name and role are visible.",
  },
  {
    number: 2,
    title: "Verify your badge",
    description: "Tap 'Verify My Badge' and photograph your badge on or over your work attire.",
  },
] as const;

export interface NoBadgeContentRedesignProps {
  isSubmitting: boolean;
  onBack: () => void;
  onPickedUpBadge: () => void;
  onSkipToClockIn: () => void;
}

export function NoBadgeContentRedesign(props: NoBadgeContentRedesignProps) {
  const { isSubmitting, onBack, onPickedUpBadge, onSkipToClockIn } = props;

  return (
    <>
      <PageHeaderWrapper variant="tertiary">
        <PageHeaderTopRow onClickBack={onBack} />
      </PageHeaderWrapper>

      <DialogContent sx={{ paddingTop: 5 }}>
        <Stack spacing={12}>
          <Stack spacing={1}>
            <Title semibold component="h1" variant="h3">
              Don't have a badge?
            </Title>
            <Title semibold component="h1" variant="h3">
              Get a temporary one
            </Title>
          </Stack>

          <Stack spacing={8}>
            {NO_BADGE_STEPS.map((step) => (
              <Stack key={step.number} direction="row" spacing={3} alignItems="flex-start">
                <Text bold variant="h6" sx={{ minWidth: "20px", textAlign: "center" }}>
                  {step.number}
                </Text>
                <Stack spacing={2}>
                  <Text bold variant="body1">
                    {step.title}
                  </Text>
                  <Text variant="body2" color={(theme) => theme.palette.text.secondary}>
                    {step.description}
                  </Text>
                </Stack>
              </Stack>
            ))}
          </Stack>
        </Stack>
      </DialogContent>

      <DialogFooter orientation="vertical">
        <Button
          fullWidth
          variant="contained"
          size="large"
          disabled={isSubmitting}
          onClick={onPickedUpBadge}
        >
          Picked up a temporary badge
        </Button>
        <LoadingButton
          fullWidth
          variant="outlined"
          size="large"
          isLoading={isSubmitting}
          onClick={onSkipToClockIn}
        >
          Skip badge verification
        </LoadingButton>
      </DialogFooter>
    </>
  );
}
